export const VERSION = '6.36.0'; // x-release-please-version
